module.exports = __webpack_public_path__ + "img/img92.2058b048.svg";